module.exports = __webpack_public_path__ + "img/idcardPhoto.2d3009d9.png";